export function allocUnsafe(size) {
    return new Uint8Array(size);
}
//# sourceMappingURL=alloc-unsafe-browser.js.map